import React from "react";
import { FiChevronRight } from "react-icons/fi";
import { KeyAudit, VehicleAudit } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { locationDescription } from "../condensedLayoutUtils";
import styles from "../styles";
import { Trans } from "react-i18next";

const AuditHistoryRow: React.FunctionComponent<{
    audit: KeyAudit | VehicleAudit,
    auditType: string,
    rowIndex: number,
    onClick: () => void
}> = (props) => {
    const { toFormattedFullDateTimeString } = useDate();
    const { audit, auditType, rowIndex } = props;
    const { createdBy, createDate, location, missingCount, scanCount, unexpectedCount } = audit;

    const rowStyles = {
        ...(rowIndex % 2 ? styles.tableRowOdd : styles.tableRowEven),
        cursor: "pointer",
    };

    return (<tr style={rowStyles} onClick={props.onClick}>
        <td style={styles.tableCell}>{auditType}</td>
        <td style={styles.tableCell}>{locationDescription(location)}</td>
        <td style={styles.tableCell}>
            <Trans i18nKey="locations.missingCounts">
                {{ missingCount: missingCount }} Missing, {{ unexpectedCount: unexpectedCount }} Unexpected, {{ scanned: scanCount }} Scanned
            </Trans>
        </td>
        <td style={styles.tableCell}>{`${createdBy.firstName} ${createdBy.lastName}`}</td>
        <td style={styles.tableCell}>{toFormattedFullDateTimeString(createDate)}</td>
        <td style={styles.tableCell}><FiChevronRight /></td>
    </tr>)
}

export default AuditHistoryRow;
